import { render } from "./NoAccountPage.vue?vue&type=template&id=796a9f72"
import script from "./NoAccountPage.vue?vue&type=script&lang=js"
export * from "./NoAccountPage.vue?vue&type=script&lang=js"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCardSection});
